import { render, staticRenderFns } from "./CupomDescontoForm.vue?vue&type=template&id=4786573e&scoped=true&"
import script from "./CupomDescontoForm.vue?vue&type=script&lang=js&"
export * from "./CupomDescontoForm.vue?vue&type=script&lang=js&"
import style0 from "./CupomDescontoForm.vue?vue&type=style&index=0&id=4786573e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786573e",
  null
  
)

export default component.exports